export const excelName = '货位品种关系维护'
export const headerData = ['包装单位', '包装数量', '包装规格', '库房名称',
  '限定类型', '逻辑区域', '货位编号', '可收货', '可发货', '顺序', '仓库']
export const filterVal = ['uom', 'factor', 'specification', 'storageRoom',
  'limitType', 'region', 'location', 'receivable', 'shippable', 'ordinal', 'warehouse']